import moment from 'moment';
import R from 'ramda';
import uuidV4 from 'uuid';

export const onSelectType = (e, fields, type) => {
  e.preventDefault();
  fields.$setValue('type', type);
  if (type === 'room' || type === 'commercial') {
    fields.$setValue('bedrooms', 0);
  }
};

export const onIncreaseBedrooms = (e, fields) => {
  e.preventDefault();
  fields.$setValue('bedrooms', fields.bedrooms.value + 1);
};

export const onDecreaseBedrooms = (e, fields) => {
  e.preventDefault();
  fields.$setValue('bedrooms', fields.bedrooms.value - 1);
};

export const onFromDateChange = (fields, date) => {
  const fromDate = moment(date);
  const toDate = moment(fields.availableTo.value);

  if (fromDate.diff(toDate, 'days') > 0) { fields.$setValue('availableTo', moment(date).format('YYYY-MM-DD')); }
  fields.$setValue('availableFrom', moment(date).format('YYYY-MM-DD'));
};

export const onToDateChange = (fields, date) => { fields.$setValue('availableTo', moment(date).format('YYYY-MM-DD')); };

export const onSelectProsCons = (e, fields, value, input) => {
  e.preventDefault();
  fields.$setValue(input, value);
};

export const formatDate = date => `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;

export const rotateAndStoreImage = (component, loadImage, loadedImage, orientation,
  imageFiles, imagePreviewUrls) => {
  const key = uuidV4();
  const canvas = loadImage.scale(loadedImage, {
    orientation: orientation || 0, maxWidth: 1600, maxHeight: 1600, crop: true, crossOrigin: 'Anonymous',
  });
  const dataURL = canvas.toDataURL();
  imageFiles.push({ key, value: dataURL.substring((dataURL.indexOf(',') + 1), dataURL.length) });
  imagePreviewUrls.push({ key, value: dataURL });
  component.setState({
    imageFiles,
    imagePreviewUrls,
  });
};

export const readAndStoreImage = (component, file, imageFiles, imagePreviewUrls) => {
  /* eslint-disable no-undef */
  const key = uuidV4();
  const reader = new FileReader();
  reader.onloadend = () => {
    imageFiles.push({ key, value: file });
    imagePreviewUrls.push({ key, value: reader.result });
    component.setState({
      imageFiles,
      imagePreviewUrls,
    });
  };
  reader.readAsDataURL(file);
};

export const loadFile = (component, loadImage, exif, file, imageFiles, imagePreviewUrls) => {
  loadImage(
    file,
    (loadedImage) => {
      exif.getData(file, () => {
        const orientation = exif.getTag(file, 'Orientation');
        if (orientation && orientation !== 1) {
          rotateAndStoreImage(component, loadImage, loadedImage,
            orientation, imageFiles, imagePreviewUrls);
        } else {
          readAndStoreImage(component, file, imageFiles, imagePreviewUrls);
        }
      });
    },
    { crossOrigin: 'Anonymous' },
  );
};

export const onImageChange = (e, loadImage, exif, component, imageFiles, imagePreviewUrls,
  numberOfExistingImages) => {
  e.preventDefault();
  for (let i = 0; i < e.target.files.length; i += 1) {
    const file = e.target.files[i];
    if (!file.type.match('image.*')) {
      component.setState({ fileTypeError: true });
      return;
    }
    if (file.size > 5000000) {
      component.setState({ uploadImageError: true });
      return;
    }
    if ((imagePreviewUrls.length + numberOfExistingImages) > 15 ||
      ((imagePreviewUrls.length + e.target.files.length + numberOfExistingImages) > 15)) {
      component.setState({ imageLimitExceeded: true });
      return;
    }
    loadFile(component, loadImage, exif, file, imageFiles, imagePreviewUrls);
  }
};

export const onDeselectImage = (e, component, key, imageFiles, imagePreviewUrls) => {
  e.preventDefault();
  component.setState({
    imageFiles: R.reject(imageFile => imageFile.key === key, imageFiles),
    imagePreviewUrls: R.reject(imagePreviewUrl => imagePreviewUrl.key === key, imagePreviewUrls),
  });
};

export const handleImageDialogClose = (component) => {
  component.setState({ uploadImageError: false, imageLimitExceeded: false, fileTypeError: false });
};

export const handleDeleteDialogClose = (component) => {
  component.setState({ confirmDelete: false });
};

export const handleDeleteDialogOpen = (e, component) => {
  e.preventDefault();
  component.setState({ confirmDelete: true });
};

export const handleDeactivateDialogClose = (component) => {
  component.setState({ confirmDeactivate: false });
};

export const handleDeactivateDialogOpen = (e, component) => {
  e.preventDefault();
  component.setState({ confirmDeactivate: true });
};

export const handleActivateDialogClose = (component) => {
  component.setState({ confirmActivate: false });
};

export const handleActivateDialogOpen = (e, component) => {
  e.preventDefault();
  component.setState({ confirmActivate: true });
};

export const onSelectContactInfo = (component, fields, isInputChecked, input) => {
  if (isInputChecked && input === 'contactEmail') { component.contactEmailValue.input.focus(); }
  if (isInputChecked && input === 'contactPhonenumber') { component.contactPhonenumberValue.input.refs.input.focus(); }
  fields.$setValue(input, isInputChecked);
};

export const assignRef = (component, field, c) => {
  switch (field) {
    case 'address':
      component.address = c;
      break;
    case 'zip':
      component.zip = c;
      break;
    case 'size':
      component.size = c;
      break;
    case 'price':
      component.price = c;
      break;
    case 'insuranceAmount':
      component.insuranceAmount = c;
      break;
    case 'description':
      component.description = c;
      break;
    case 'title':
      component.title = c;
      break;
    case 'contactPhonenumberValue':
      component.contactPhonenumberValue = c;
      break;
    case 'contactEmailValue':
      component.contactEmailValue = c;
      break;
    default:
      break;
  }
};



// WEBPACK FOOTER //
// ./src/common/properties/formFunctions.js